import styled from 'styled-components';

export const ProgressWrapper = styled.div`
  margin: 1rem auto;
  display: flex;
  justify-content: center;
`;

export const AnimatedCircle = styled.circle`
  transition-duration: 0.3s;
`;


// WEBPACK FOOTER //
// src/app/src/components/FormProgress/FormProgress.s.ts